import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import DNDDescription from "./cardtypes/DNDDescription";
import DNDImage from "./cardtypes/DNDImage";
import DNDVideo from "./cardtypes/DNDVideo";
import DNDGallery from "./cardtypes/DNDGallery";
import DNDVerificationSuccessful from "./cardtypes/DNDVerificationSuccessful";
import DNDPin from "./cardtypes/DNDPin";
import DNDRedirect from "./cardtypes/DNDRedirect";
import DNDNoScript from "./cardtypes/DNDNoScript";
import DNDButton from "./cardtypes/DNDButton";
import { aligmnentElements, getElementStyle } from "../rptemplate";
import DNDSlotmachine from "./cardtypes/DNDSlotMachine";

export const DNDElement = ({
  id,
  card,
  index,
  moveCard,
  setSelectedComponentIndex,
  hidden = false,
  lastElement,
  language = "en",
}) => {
  const ref = useRef(null);
  const [{ handlerId }, drop] = useDrop({
    accept: "card",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      setSelectedComponentIndex(hoverIndex);
      moveCard(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  function changeSelection() {
    setSelectedComponentIndex(index);
  }

  const elementStyle = getElementStyle(card);

  return (
    <div
      key={id}
      id={card.name === "pin" ? "pinComponent" : ""}
      name="reactComponent"
      ref={ref}
      style={{
        border: "1px dashed gray",
        cursor: "move",
        opacity,
        flex: card?.startFooter ? "inherit" : "unset",
        alignItems: card?.startFooter ? "end" : "",
        display:
          card.displayDefault === undefined || card.displayDefault
            ? ""
            : "inherit",
      }}
      data-handler-id={handlerId}
    >
      {card.name === "description" && (
        <DNDDescription
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      
      {card.name === "image" && (
        <DNDImage
          imgWidth={card?.imgWidth}
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "video" && (
        <DNDVideo
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "verificationSuccessful" && (
        <DNDVerificationSuccessful
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "pin" && (
        <DNDPin
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "redirect" && (
        <DNDRedirect
          src={card.value[0].languages[language]}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "button" && (
        <DNDButton
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "gallery" && (
        <DNDGallery
          imgWidth={card?.imgWidth}
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "noscript" && (
        <DNDNoScript
          src={card.value[0].languages[language]}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
      {card.name === "slotmachine" && (
        <DNDSlotmachine
          card={card}
          language={language}
          elementStyle={elementStyle}
          changeSelection={changeSelection}
        />
      )}
    </div>
  );
};
